(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5555],{

/***/ 92039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10 3.75a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 3.75Zm0 5a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 8.75Zm0 5a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 13.75Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgDotsVertical);

/***/ }),

/***/ 30853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createReactComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/defaultAttributes.js
/**
 * @tabler/icons-react v2.22.0 - MIT
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/createReactComponent.js
/**
 * @tabler/icons-react v2.22.0 - MIT
 */





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var createReactComponent = (iconName, iconNamePascal, iconNode) => {
  const Component = (0,react.forwardRef)(
    (_a, ref) => {
      var _b = _a, { color = "currentColor", size = 24, stroke = 2, children } = _b, rest = __objRest(_b, ["color", "size", "stroke", "children"]);
      return (0,react.createElement)(
        "svg",
        __spreadValues(__spreadProps(__spreadValues({
          ref
        }, defaultAttributes), {
          width: size,
          height: size,
          stroke: color,
          strokeWidth: stroke,
          className: `tabler-icon tabler-icon-${iconName}`
        }), rest),
        [...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)), ...children || []]
      );
    }
  );
  Component.propTypes = {
    color: (prop_types_default()).string,
    size: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
    stroke: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])
  };
  Component.displayName = `${iconNamePascal}`;
  return Component;
};


//# sourceMappingURL=createReactComponent.js.map


/***/ }),

/***/ 53865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconChevronRight; }
/* harmony export */ });
/* harmony import */ var _createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30853);
/**
 * @tabler/icons-react v2.22.0 - MIT
 */



var IconChevronRight = (0,_createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("chevron-right", "IconChevronRight", [
  ["path", { d: "M9 6l6 6l-6 6", key: "svg-0" }]
]);


//# sourceMappingURL=IconChevronRight.js.map


/***/ }),

/***/ 20168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ HeaderNavigation; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95571);
/* harmony import */ var _header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);






const HeaderNavigation = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_navigation), props.sticky && (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sticky), props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().menu),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inner),
                children: props.menu.map((it, key)=>{
                    const active = it.exact ? router.asPath === it.href : router.asPath.startsWith(it.href);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: it.href,
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                        children: it.label
                    }, it.href);
                })
            })
        })
    });
};
HeaderNavigation.defaultProps = {};


/***/ }),

/***/ 68264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ Empty; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97485);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_empty_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Empty = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_empty_module_scss__WEBPACK_IMPORTED_MODULE_3___default().empty), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            (props.title || props.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_3___default().body),
                children: [
                    props.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                        children: props.title
                    }),
                    props.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
                        children: props.description
                    })
                ]
            }),
            props.actions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_3___default().actions),
                children: props.actions
            })
        ]
    });
};
Empty.defaultProps = {};


/***/ }),

/***/ 37641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ EntityForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33279);
/* harmony import */ var _entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3__);





const EntityForm = (props)=>{
    const footerStyle = props.primaryAction && props.primaryAction && props.secondaryAction;
    const hasActions = props.primaryAction || props.primaryAction || props.secondaryAction;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default().entity_form), "entity-form", props.disabled && (_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default().disabled), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            props.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default().header),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: (_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                        children: props.title
                    }),
                    props.extraActions
                ]
            }),
            props.children,
            props.footerNote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default().note),
                        children: props.footerNote
                    }),
                    !footerStyle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer_btns),
                        children: [
                            props.destructiveAction,
                            props.secondaryAction,
                            props.primaryAction
                        ]
                    })
                ]
            }),
            footerStyle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer_btns),
                        children: [
                            props.secondaryAction,
                            props.destructiveAction
                        ]
                    }),
                    props.primaryAction
                ]
            }),
            !props.footerNote && !footerStyle && hasActions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_entity_form_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer_btns),
                        children: [
                            props.secondaryAction,
                            props.destructiveAction
                        ]
                    }),
                    props.primaryAction
                ]
            })
        ]
    });
};


/***/ }),

/***/ 51978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ Entity; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/shared/ui/entity/entity-menu-context.tsx

const EntityMenuContext = /*#__PURE__*/ react.createContext(null);

// EXTERNAL MODULE: ./src/shared/ui/icon/dots-vertical.svg
var dots_vertical = __webpack_require__(92039);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/container/menu-container.tsx
var menu_container = __webpack_require__(8581);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/button/menu-button.tsx
var menu_button = __webpack_require__(92422);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/menu/menu.tsx
var menu = __webpack_require__(78024);
// EXTERNAL MODULE: ./src/shared/ui/entity/actions/entity-actions.module.scss
var entity_actions_module = __webpack_require__(3115);
var entity_actions_module_default = /*#__PURE__*/__webpack_require__.n(entity_actions_module);
;// CONCATENATED MODULE: ./src/shared/ui/entity/actions/entity-actions.tsx







const EntityActions = (props)=>{
    const menuItems = (0,react.useContext)(EntityMenuContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((entity_actions_module_default()).entity_actions, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            props.children,
            menuItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (entity_actions_module_default()).menu_button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_container/* MenuContainer */.F, {
                    placement: "bottom-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_button/* MenuButton */.j, {
                            size: "small",
                            svgOnly: true,
                            variant: "unstyled",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dots_vertical/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
                            minWidth: 150,
                            children: menuItems
                        })
                    ]
                })
            })
        ]
    });
};
EntityActions.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/entity/entity.module.scss
var entity_module = __webpack_require__(68404);
var entity_module_default = /*#__PURE__*/__webpack_require__.n(entity_module);
// EXTERNAL MODULE: ./src/shared/ui/entity/field/entity-field.module.scss
var entity_field_module = __webpack_require__(38244);
var entity_field_module_default = /*#__PURE__*/__webpack_require__.n(entity_field_module);
;// CONCATENATED MODULE: ./src/shared/ui/entity/field/entity-field.tsx







const EntityField = (props)=>{
    const style = (0,react.useMemo)(()=>{
        const width = typeof props.width === "number" ? props.width + "px" : props.width;
        if (!width) {
            return props.style;
        } else {
            return {
                ...props.style,
                flex: "0 0 ".concat(width)
            };
        }
    }, [
        props.style,
        props.width
    ]);
    const menuItems = (0,react.useContext)(EntityMenuContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((entity_field_module_default()).entity_field, props.flex && (entity_field_module_default()).flex, props.right && (entity_field_module_default()).right, props.label && (entity_field_module_default()).label, props.className),
        style: style,
        id: props.htmlId,
        children: [
            props.avatar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: props.avatar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((entity_field_module_default()).content),
                id: props.htmlId,
                children: [
                    props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (entity_field_module_default()).title,
                        children: props.title
                    }),
                    props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (entity_field_module_default()).description,
                        children: props.description
                    }),
                    props.children
                ]
            }),
            menuItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (entity_field_module_default()).menu_button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_container/* MenuContainer */.F, {
                    placement: "bottom-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_button/* MenuButton */.j, {
                            size: "small",
                            svgOnly: true,
                            variant: "unstyled",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dots_vertical/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
                            minWidth: 150,
                            children: menuItems
                        })
                    ]
                })
            })
        ]
    });
};
EntityField.defaultProps = {};

;// CONCATENATED MODULE: ./src/shared/ui/entity/entity.tsx







const Entity = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((entity_module_default()).entity, props.hover && (entity_module_default()).hover, "entity", props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EntityMenuContext.Provider, {
                value: props.menuItems,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (entity_module_default()).content,
                    style: {
                        "--flex": 1
                    },
                    children: [
                        props.checkbox && /*#__PURE__*/ (0,jsx_runtime.jsx)(Entity.Field, {
                            width: 16,
                            children: props.checkbox
                        }),
                        props.children
                    ]
                })
            }),
            props.footer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (entity_module_default()).footer,
                children: props.footer
            })
        ]
    });
};
Entity.Field = EntityField;
Entity.Actions = EntityActions;
Entity.defaultProps = {};


/***/ }),

/***/ 30954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ List; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var shared_ui_empty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68264);
/* harmony import */ var shared_ui_loading_dots__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42966);
/* harmony import */ var _list_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74383);
/* harmony import */ var _list_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_list_module_scss__WEBPACK_IMPORTED_MODULE_3__);






const List = (props)=>{
    var _props_data, _props_data1;
    if (props.isLoading && !props.error && !props.data) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_list_module_scss__WEBPACK_IMPORTED_MODULE_3___default().list), props.className),
            style: props.style,
            id: props.htmlId,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_list_module_scss__WEBPACK_IMPORTED_MODULE_3___default().loading),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui_loading_dots__WEBPACK_IMPORTED_MODULE_4__/* .LoadingDots */ .x, {
                    size: 10
                })
            })
        });
    }
    if (((_props_data = props.data) === null || _props_data === void 0 ? void 0 : _props_data.length) === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_list_module_scss__WEBPACK_IMPORTED_MODULE_3___default().list), props.className),
            style: props.style,
            id: props.htmlId,
            children: props.empty || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui_empty__WEBPACK_IMPORTED_MODULE_5__/* .Empty */ .H, {
                title: "Нет данных"
            })
        });
    }
    if (!props.data && props.error) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_list_module_scss__WEBPACK_IMPORTED_MODULE_3___default().list), props.className),
            style: props.style,
            id: props.htmlId,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui_empty__WEBPACK_IMPORTED_MODULE_5__/* .Empty */ .H, {
                title: "Ошибка загрузки",
                description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", {
                        children: JSON.stringify(props.error, null, 2)
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_list_module_scss__WEBPACK_IMPORTED_MODULE_3___default().list), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            props.header,
            (_props_data1 = props.data) === null || _props_data1 === void 0 ? void 0 : _props_data1.map((it, key)=>{
                var _props_renderItem;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                    children: (_props_renderItem = props.renderItem) === null || _props_renderItem === void 0 ? void 0 : _props_renderItem.call(props, it)
                }, it.id || key);
            }),
            props.footer
        ]
    });
};
List.defaultProps = {
    renderItem: (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", {
                children: JSON.stringify(props, null, 2)
            })
        })
};


/***/ }),

/***/ 95571:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header_navigation":"header-navigation_header_navigation__k37R9","sticky":"header-navigation_sticky__awsUq","menu":"header-navigation_menu__cb9yS","inner":"header-navigation_inner__OtSJ_","item":"header-navigation_item__FmE4u","active":"header-navigation_active__1bau7"};

/***/ }),

/***/ 97485:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"empty":"empty_empty__AbE8_","body":"empty_body__s2QO8","title":"empty_title__NXsFg","description":"empty_description__AoiKG","actions":"empty_actions__a3nhX"};

/***/ }),

/***/ 33279:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"entity_form":"entity-form_entity_form__Yw6Cm","header":"entity-form_header___IEOH","title":"entity-form_title__s0yRj","footer":"entity-form_footer__imBnU","note":"entity-form_note__WeD07","footer_btns":"entity-form_footer_btns__O3Cu9","disabled":"entity-form_disabled__lulAV"};

/***/ }),

/***/ 3115:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"entity_actions":"entity-actions_entity_actions___FIaQ","menu_button":"entity-actions_menu_button__8wzDR"};

/***/ }),

/***/ 68404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"entity":"entity_entity__AWEQ3","content":"entity_content__7lRgo","entityMenu":"entity_entityMenu__m3g7R","footer":"entity_footer__7mvpx","hover":"entity_hover__ZZX8T"};

/***/ }),

/***/ 38244:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"entity_field":"entity-field_entity_field__QGeVR","content":"entity-field_content__xjWlB","title":"entity-field_title__nABa2","description":"entity-field_description__a2Fok","label":"entity-field_label__t3sOk","right":"entity-field_right__g1CEA","menu_button":"entity-field_menu_button__99rEj","flex":"entity-field_flex____qwg"};

/***/ }),

/***/ 74383:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"list_loading__1Ubrr"};

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};exports.isFragment=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ })

}]);